import { Link } from '@tanstack/react-router';
import { cn } from '@/lib/utils';

interface SubNavItem {
  to: string;
  label: string;
  end?: boolean;
}

interface SubNavProps {
  items: SubNavItem[];
}

export function SubNav({ items }: SubNavProps) {
  return (
    <nav className="mb-6 flex gap-1 border-b border-border">
      {items.map(({ to, label, end }) => (
        <Link
          key={to}
          to={to}
          className={cn(
            '-mb-px rounded-t-md px-4 py-2 text-sm font-medium transition-colors',
            'text-muted-foreground hover:text-foreground'
          )}
          activeProps={{
            className: cn(
              '-mb-px rounded-t-md px-4 py-2 text-sm font-medium transition-colors',
              'border-b-2 border-primary text-primary'
            ),
          }}
          activeOptions={{ exact: end }}
        >
          {label}
        </Link>
      ))}
    </nav>
  );
}
